import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-wrapper" }
const _hoisted_2 = { class: "page-wrapper full-page" }
const _hoisted_3 = { class: "page-content d-flex align-items-center justify-content-center" }
const _hoisted_4 = { class: "row w-100 mx-0 auth-page" }
const _hoisted_5 = { class: "col-md-8 col-xl-6 mx-auto" }
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4 pe-md-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "auth-side-wrapper" })
], -1)
const _hoisted_9 = { class: "col-md-8 ps-md-0" }
const _hoisted_10 = { class: "auth-form-wrapper px-4 py-5" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h5", { class: "text-muted fw-normal mb-4" }, " Welcome back! Log in to your account. ", -1)
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "userEmail",
  class: "form-label"
}, "Email address", -1)
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: "userPassword",
  class: "form-label"
}, "Password", -1)
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "feather feather-lock btn-icon-prepend"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "3",
    y: "11",
    width: "18",
    height: "11",
    rx: "2",
    ry: "2"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })
], -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Login ")
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_alert = _resolveComponent("alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    (_ctx.isError)
                      ? (_openBlock(), _createBlock(_component_alert, {
                          key: 0,
                          type: _ctx.type,
                          message: _ctx.message,
                          onCloseError: _cache[0] || (_cache[0] = (onClose) => (_ctx.isError = onClose))
                        }, null, 8, ["type", "message"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("form", {
                      class: "forms-sample",
                      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmitRequest && _ctx.handleSubmitRequest(...args)), ["prevent"]))
                    }, [
                      _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _withDirectives(_createElementVNode("input", {
                          type: "email",
                          class: "form-control",
                          id: "userEmail",
                          placeholder: "Email",
                          required: "",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.email]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _withDirectives(_createElementVNode("input", {
                          type: "password",
                          class: "form-control",
                          id: "userPassword",
                          autocomplete: "current-password",
                          placeholder: "Password",
                          required: "",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.password]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("button", {
                          disabled: _ctx.isDisabled,
                          class: _normalizeClass([{ cursor: _ctx.isDisabled }, "btn btn-outline-primary btn-icon-text mb-2 mb-md-0"]),
                          type: "submit"
                        }, _hoisted_19, 10, _hoisted_16)
                      ])
                    ], 32)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}